export default __webpack_public_path__ + "static/media/Hero.fb89fc93.png";